<template>
	<section :id="id" class="cmeinfo-bar w-full bg-bg-003 shadow-default">
		<div class="wrapper">
			<div class="container grid grid-cols-12 gap-4 overflow-hidden">
				<div class="grid-item col-span-12 lg:col-span-8 py-5">
					<header class="flex flex-col md:flex-row justify-between item-start md:items-center">
						<div class="mb-4 md:mb-0">
							<button 
								class="flex flex-row justify-center items-center"
								@click="toggleInfo"
							>
								<strong>{{ label }} Info & Disclosures</strong>
								<UiIcon v-if="isActive" name="chevronUp"/>
								<UiIcon v-else name="chevronDown"/>
							</button>
						</div>
						<div class="flex flex-row flex-nowrap">
							<UiButton
								class="md:ml-4"
								label="More Information"
								:width="220"
								:on-click="showCmeInfoModal"
							/>
							<UiButton
								class="ml-4"
								label="Claim Credit"
								:width="180"
								:on-click="claimCredit"
							/>
						</div>
					</header>
					<transition 
						@before-enter="beforeExpand" @enter="expanded"
						@before-leave="beforeCollapse" @leave="collapsed"
					>
						<section v-if="isActive" class="cmeinfo-content animate--collapsible mt-4">
							<div class="mb-4">
								<p class="mb-2">Must be read prior to engaging in the activity.</p>
								<!-- <p class="mb-2" v-html="funderLine"></p> -->
							</div>
							<div>
								<p class="mb-2"><strong>Disclosure Information</strong></p>
								<p class="mb-2">The Disclosure Policy of Projects In Knowledge® requires that presenters comply with the Standards for Integrity and Independence in Accredited Continuing Education. All faculty are required to disclose any<button @click="showCmeInfoModal">...</button></p>
								<p class="mb-2">All hyperlinks included in this activity will open in a new window, and are provided solely as additional reference material. We do not own, control, or have influence over the contents.</p>
							</div>
						</section>
					</transition>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import globalMixins from '@/mixins/global-mixins'

import UiButton from '@/components/ui/Button'
import UiIcon from '@/components/ui/Icon'

/* eslint-disable no-console */
export default {
	name: 'CmeInfoBar',
	components: {
		UiButton,
		UiIcon,
	},
	mixins: [
		globalMixins
	],
	props: {
		id: {
			type: String,
			default: 'cmeInfoBar'
		},
		isSticky: {
			type: Boolean,
			default: false
		},
		jobnum: {
			type: String,
			default: null
		},
		label: {
			type: String,
			default: null
		},
		funderLine: {
			type: String,
			default: null
		}
	},
	data() {
		return {
			offsetTop: 0,
			isActive: false
		}
	},
  beforeMount() {
		if (this.isSticky) {
			this.setOffsetTop()
			// this.stickyNav()
			window.addEventListener('scroll', this.stickyNav)
			window.addEventListener('resize', this.setOffsetTop)
		}
  },
	mounted() {
		this.$refs?.funderLine?.insertAdjacentHTML('afterbegin', this.funderLine)
	},
  beforeUnmount() {
		if (this.isSticky) {
			window.removeEventListener('scroll', this.stickyNav)
			window.removeEventListener('resize', this.setOffsetTop)
		}
  },
  methods: {
		toggleInfo() {
			this.isActive = !this.isActive
		},
		setOffsetTop() {
			this.offsetTop = this.getOffsetTop(['#pageHeader','#funderLine'])
		},
    stickyNav () {
			const navbar = this.$el
			if (window.pageYOffset >= this.offsetTop) {
				navbar.classList.add('sticky-navbar')
				this.setContentMargin()
				if (this.isActive) this.toggleInfo()
			} else {
				navbar.classList.remove('sticky-navbar');
				this.setContentMargin()
			}
    },
		claimCredit() {
			if (this.isAuth) {
				this.openNewTab(this.claimCreditUrl, {
					jn: this.jobnum,
					token: this.userToken
				})
				this.analytics({
					event: 'Click',
					label: 'Claim Credit | ' + this.claimCreditUrl
				})
			}
			else {
				this.showCmeRegModal()
			}
		}
  }
}
</script>

<style src="@/assets/css/tailwind.css"></style>
<style src="@/assets/css/_config.css"></style>
<style src="@/assets/css/_global.css"></style>
<style src="@/assets/css/animations.css"></style>
<style src="@/assets/css/main.css"></style>

<style scoped>
.cmeinfo-bar { z-index: 97; }

.sticky-navbar {
	position: fixed;
	top: var(--navbar-height-sticky-mobile) !important;
}

@media (min-width: 769px) {
	.sticky-navbar { top: var(--navbar-height) !important; }
}
</style>